/* uwelle® · Todos los productos (/collections/all) · 29 sep 2026
   Filtros por cabello, tipo y momento, buscador con sinónimos, orden, franja
   «Tu ritual, en orden», selector Gelée/Mousse, barra de envío gratis y hoja
   de filtros del teléfono. Sin dependencias.
   Si este archivo no carga, la página se sigue pudiendo comprar: la retícula
   ya viene pintada en orden del ritual y cada tarjeta es el formulario nativo
   del tema.
   30 sep 2026 · La barra de envío vuelve a su texto inicial si el carrito se
   vacía (antes se quedaba en «Te faltan…» con el avance anterior); precios con
   espacio de no separación («$ 1,175» no se parte); y la tarjeta que queda
   sola en su fila en la retícula de dos columnas se abre a lo ancho (foto a la
   izquierda, datos a la derecha) en lugar de dejar un hueco. */
(function () {
  'use strict';

  var MOM = { ducha: 'En la ducha', gorro: 'Bajo el gorro', humedo: 'Al salir de la ducha', forma: 'Al peinar', noche: 'Por la noche' };
  var TIPO = { shampoo: 'Shampoo', acond: 'Acondicionador', trat: 'Tratamiento', masc: 'Mascarilla', acabado: 'Acabado', ritual: 'Rituales completos' };
  var HASH = { cabello: 'line', tipo: 'type', momento: 'mom', q: 'q' };

  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9ñ ]/g, ' ').replace(/\s+/g, ' ').trim(); }
  function fmt(c) { return '$ ' + Math.round(c / 100).toLocaleString('en-US'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init(root) {
    if (root.__uwt) return; root.__uwt = true;

    var grid = root.querySelector('[data-uwt-grid]');
    var items = [].slice.call(root.querySelectorAll('[data-uwt-item]'));
    var head = root.querySelector('[data-uwt-gh]');
    var empty = root.querySelector('[data-uwt-empty]');
    var side = root.querySelector('[data-uwt-side]');
    var velo = root.querySelector('[data-uwt-velo]');
    var umbral = +root.dataset.umbral || 69900;
    var st = { line: '', type: '', mom: '', q: '', sort: 'ritual' };

    /* ── sinónimos: «clave: palabras», una línea por clave ── */
    var SIN = {};
    try {
      var raw = JSON.parse(root.querySelector('[data-uwt-sin]').textContent) || '';
      raw.split(/\n/).forEach(function (l) { var i = l.indexOf(':'); if (i > 0) SIN[norm(l.slice(0, i))] = norm(l.slice(i + 1)); });
    } catch (e) {}

    var LINEAS = {};
    items.forEach(function (el) {
      var d = el.dataset;
      el._kw = ' ' + norm([d.kw, SIN[d.line], SIN[d.type], SIN[d.mom], SIN[d.h]].join(' ')) + ' ';
      el._o = +d.o; el._p = +d.p;
      LINEAS[d.line] = true;
    });
    /* colección de una sola línea (/collections/ulisse): su franja se ve
       siempre y el grupo «Tu cabello» sobra */
    var lk = Object.keys(LINEAS).filter(function (k) { return k !== 'otro'; });
    var UNICA = lk.length === 1 ? lk[0] : '';
    if (UNICA) { var gl = root.querySelector('[data-uwt-f="line"]'); if (gl && gl.closest('.uwt-g')) gl.closest('.uwt-g').hidden = true; }
    var chipsRow = root.querySelector('[data-uwt-chips]');
    if (UNICA && chipsRow) chipsRow.hidden = true;
    var promo = root.querySelector('[data-uwt-promo]');

    /* ── estado en la dirección, para anuncios y WhatsApp ── */
    function leerHash() {
      (location.hash || '').replace(/^#/, '').split('&').forEach(function (kv) {
        var a = kv.split('='); if (HASH[a[0]]) st[HASH[a[0]]] = decodeURIComponent(a[1] || '').replace(/\+/g, ' ');
      });
    }
    function escribirHash() {
      var h = [];
      if (st.line) h.push('cabello=' + st.line);
      if (st.type) h.push('tipo=' + st.type);
      if (st.mom) h.push('momento=' + st.mom);
      if (st.q) h.push('q=' + encodeURIComponent(st.q));
      try { history.replaceState(null, '', h.length ? '#' + h.join('&') : location.pathname + location.search); } catch (e) {}
    }

    function toks(q) { return norm(q).split(' ').filter(function (t) { return t.length > 1; }); }
    function pasa(el, s) {
      var d = el.dataset;
      if (s.line && d.line !== s.line) return false;
      if (s.type && d.type !== s.type) return false;
      if (s.mom && d.mom !== s.mom) return false;
      var t = toks(s.q);
      for (var i = 0; i < t.length; i++) { if (el._kw.indexOf(t[i]) < 0) return false; }
      return true;
    }
    function cuenta(f, v) {
      var s = Object.assign({}, st); s[f] = v;
      return items.filter(function (el) { return pasa(el, s); }).length;
    }

    /* ── pintar ── */
    var tLayer;
    function pintar(origen) {
      var vis = 0, visRit = 0, visProd = 0;
      items.forEach(function (el) {
        var ok = pasa(el, st);
        el.hidden = !ok;
        if (ok) { vis++; if (el.dataset.type === 'ritual') visRit++; else visProd++; }
      });
      if (head) head.hidden = !visRit;
      if (empty) empty.hidden = vis > 0;

      /* orden */
      var orden = items.slice().sort(function (a, b) {
        var ra = a.dataset.type === 'ritual', rb = b.dataset.type === 'ritual';
        if (st.sort === 'asc') return a._p - b._p;
        if (st.sort === 'desc') return b._p - a._p;
        if (ra !== rb) return ra ? 1 : -1;
        return a._o - b._o;
      });
      orden.forEach(function (el, i) {
        if (st.sort === 'ritual' && head && el.dataset.type === 'ritual' && (i === 0 || orden[i - 1].dataset.type !== 'ritual')) grid.insertBefore(head, empty);
        grid.insertBefore(el, empty);
      });
      if (head && st.sort !== 'ritual') head.hidden = true;

      /* aviso de rituales: sin filtros, tras la sexta tarjeta */
      if (promo) {
        var libre = !(st.line || st.type || st.mom || st.q);
        promo.hidden = !libre;
        if (libre) {
          var sueltos = orden.filter(function (el) { return !el.hidden && el.dataset.type !== 'ritual'; });
          grid.insertBefore(promo, sueltos[6] || head || empty);
        }
      }

      /* opciones: estado y conteos */
      root.querySelectorAll('[data-uwt-f]').forEach(function (b) {
        var f = b.dataset.uwtF, v = b.dataset.v, on = st[f] === v;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var n = cuenta(f, v), em = b.querySelector('[data-uwt-n]');
        if (em) em.textContent = n;
        b.classList.toggle('is-zero', !n && !on);
        if (f === 'line' && !LINEAS[v]) b.hidden = true;
      });
      root.querySelectorAll('.uwt-g').forEach(function (g) {
        var b = g.querySelector('[data-uwt-f]');
        g.classList.toggle('is-set', !!(b && st[b.dataset.uwtF]));
      });
      root.querySelectorAll('[data-uwt-sort]').forEach(function (s) { s.value = st.sort; });
      root.querySelectorAll('[data-uwt-q]').forEach(function (i) { if (i !== document.activeElement) i.value = st.q; });
      root.querySelectorAll('[data-uwt-clear="q"]').forEach(function (b) { if (b.classList.contains('uwt-q__x')) b.hidden = !st.q; });

      /* recuento, pastillas */
      var txt = '<b>' + vis + '</b> ' + (vis === 1 ? 'producto' : 'productos');
      root.querySelectorAll('[data-uwt-count]').forEach(function (e) { e.innerHTML = txt; });
      root.querySelectorAll('[data-uwt-mcount]').forEach(function (e) { e.innerHTML = txt; });
      root.querySelectorAll('[data-uwt-ver]').forEach(function (e) { e.textContent = vis ? 'Ver ' + vis + (vis === 1 ? ' producto' : ' productos') : 'Sin resultados'; });
      var nf = ['line', 'type', 'mom'].filter(function (k) { return st[k]; }).length + (st.q ? 1 : 0);
      root.querySelectorAll('[data-uwt-nf]').forEach(function (e) { e.textContent = nf ? '(' + nf + ')' : ''; });
      var pills = '';
      if (st.line) { var bl = root.querySelector('[data-uwt-f="line"][data-v="' + st.line + '"]'); pills += pill('line', 'Cabello', bl ? bl.dataset.lab : st.line); }
      if (st.type) pills += pill('type', 'Tipo', TIPO[st.type] || st.type);
      if (st.mom) pills += pill('mom', 'Momento', MOM[st.mom] || st.mom);
      if (st.q) pills += pill('q', 'Búsqueda', '«' + st.q + '»');
      if (pills) pills += '<button type="button" class="uwt-clear" data-uwt-clear="all">Borrar todo</button>';
      root.querySelectorAll('[data-uwt-pills]').forEach(function (e) { e.innerHTML = pills; });

      /* franja del ritual */
      root.querySelectorAll('[data-uwt-strip]').forEach(function (s) {
        var ln = st.line || UNICA;
        var on = ln && s.dataset.uwtStrip === ln && st.type !== 'ritual';
        s.hidden = !on;
        if (!on) return;
        var algun = !!(st.type || st.mom || st.q);
        s.classList.toggle('is-some', algun);
        s.querySelectorAll('li[data-h]').forEach(function (li) {
          var el = root.querySelector('[data-uwt-item][data-h="' + li.dataset.h + '"]');
          li.classList.toggle('is-hit', algun && !!el && !el.hidden);
        });
      });

      /* sugerencias cuando no hay nada */
      if (!vis) {
        var sug = '';
        ['mom', 'type', 'line', 'q'].forEach(function (k) {
          if (!st[k]) return;
          var s = Object.assign({}, st); s[k] = '';
          var n = items.filter(function (el) { return pasa(el, s); }).length;
          var nom = k === 'mom' ? MOM[st.mom] : k === 'type' ? TIPO[st.type] : k === 'q' ? st.q : (root.querySelector('[data-uwt-f="line"][data-v="' + st.line + '"]') || { dataset: {} }).dataset.lab;
          if (n) sug += '<button type="button" data-uwt-clear="' + k + '">Quitar «' + esc(nom) + '» · ' + n + '</button>';
        });
        root.querySelector('[data-uwt-sug]').innerHTML = sug;
      }

      solos();
      escribirHash();

      /* aprendizaje: qué filtra la clienta (para Meta/TikTok/Clarity vía GTM) */
      if (origen === 'usuario' && window.dataLayer) {
        clearTimeout(tLayer);
        tLayer = setTimeout(function () {
          window.dataLayer.push({ event: 'uw_filtro', cabello: st.line || '(todos)', tipo: st.type || '(todos)', momento: st.mom || '(todos)', busqueda: st.q || '', resultados: vis });
          if (!vis) window.dataLayer.push({ event: 'uw_sin_resultados', busqueda: st.q || '', cabello: st.line, tipo: st.type, momento: st.mom });
        }, 900);
      }
    }
    /* tarjeta sola en su fila: con dos columnas, la última de un tramo impar
       (antes del aviso, del encabezado de rituales o del final) se abre a lo
       ancho. Se mide la retícula real, así que respeta filtros, orden y el
       paso de escritorio a teléfono. */
    function solos() {
      if (!grid) return;
      var marcadas = grid.querySelectorAll('.is-solo');
      for (var m = 0; m < marcadas.length; m++) marcadas[m].classList.remove('is-solo');
      if (getComputedStyle(grid).gridTemplateColumns.split(' ').length !== 2) return;
      var tramo = 0, ult = null;
      function cierra() { if (tramo % 2 === 1 && ult && !ult.classList.contains('uwt-card--rit')) ult.classList.add('is-solo'); tramo = 0; ult = null; }
      [].forEach.call(grid.children, function (ch) {
        if (ch.hidden || ch.tagName === 'SCRIPT') return;
        if (getComputedStyle(ch).gridColumnEnd === '-1') { cierra(); return; }
        tramo++; ult = ch;
      });
      cierra();
    }
    ['(max-width:1100px)', '(max-width:760px)'].forEach(function (q) {
      var mq = window.matchMedia(q);
      if (mq.addEventListener) mq.addEventListener('change', solos); else if (mq.addListener) mq.addListener(solos);
    });
    addEventListener('load', solos);

    function pill(k, rot, v) { return '<button type="button" class="uwt-pill" data-uwt-clear="' + k + '">' + rot + ': <b>' + esc(v) + '</b><span aria-hidden="true">×</span><span class="visually-hidden">Quitar</span></button>'; }

    function set(p, origen) { Object.assign(st, p); pintar(origen || 'usuario'); }

    /* lleva a la clienta al inicio de los resultados (con la franja del ritual
       a la vista), descontando el encabezado fijo */
    var main = root.querySelector('.uwt-main') || grid;
    function irResultados(soloSiArriba) {
      var barra = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--barra'), 10) || 84;
      var top = main.getBoundingClientRect().top;
      if (soloSiArriba && top > barra) return;
      window.scrollTo({ top: top + window.pageYOffset - barra - 12, behavior: 'smooth' });
    }

    /* ── eventos ── */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-uwt-f]');
      if (b) {
        var o = {}; o[b.dataset.uwtF] = st[b.dataset.uwtF] === b.dataset.v ? '' : b.dataset.v; set(o);
        if (b.dataset.uwtF === 'line' && o.line && !(side && side.classList.contains('is-open'))) irResultados(true);
        if (promo && promo.contains(b)) irResultados(false);
        return;
      }
      var c = e.target.closest('[data-uwt-clear]');
      if (c) { var k = c.dataset.uwtClear; set(k === 'all' ? { line: '', type: '', mom: '', q: '' } : (function () { var o = {}; o[k] = ''; return o; })()); return; }
      var q = e.target.closest('[data-uwt-setq]');
      if (q) { set({ q: q.dataset.uwtSetq }); return; }
      if (e.target.closest('[data-uwt-open]')) { abrir(true); return; }
      if (e.target.closest('[data-uwt-close]')) { abrir(false); if (e.target.closest('[data-uwt-ver]')) irResultados(false); return; }
    });
    root.addEventListener('change', function (e) {
      var s = e.target.closest('[data-uwt-sort]'); if (s) set({ sort: s.value });
    });
    var tq;
    root.addEventListener('input', function (e) {
      var i = e.target.closest('[data-uwt-q]'); if (!i) return;
      clearTimeout(tq); tq = setTimeout(function () { set({ q: i.value }); }, 160);
    });
    root.addEventListener('keydown', function (e) {
      var i = e.target.closest('[data-uwt-q]');
      if (i && e.key === 'Enter') { e.preventDefault(); clearTimeout(tq); set({ q: i.value }); if (window.matchMedia('(max-width:900px)').matches) { abrir(false); irResultados(false); } }
    });
    if (velo) velo.addEventListener('click', function () { abrir(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && side && side.classList.contains('is-open')) abrir(false); });

    /* ── hoja de filtros en el teléfono ── */
    var abreBtn = root.querySelector('[data-uwt-open]');
    function abrir(on) {
      if (!side) return;
      side.classList.toggle('is-open', on);
      if (velo) velo.hidden = !on;
      if (abreBtn) abreBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      document.documentElement.style.overflow = on ? 'hidden' : '';
      if (on) { var x = side.querySelector('[data-uwt-close]'); if (x) x.focus({ preventScroll: true }); }
      else if (abreBtn && window.matchMedia('(max-width:900px)').matches) abreBtn.focus({ preventScroll: true });
    }

    /* ── selector Gelée / Mousse del ritual ── */
    root.querySelectorAll('[data-uwt-rit]').forEach(function (card) {
      var vars = []; try { vars = JSON.parse(card.querySelector('[data-uwt-vars]').textContent); } catch (e) {}
      var vid = card.querySelector('[data-uwt-vid]');
      card.querySelectorAll('[data-uwt-sel] input').forEach(function (i) {
        i.addEventListener('change', function () {
          var v = vars.filter(function (x) { return String(x.id) === i.value; })[0]; if (!v) return;
          if (vid) vid.value = v.id;
          card.dataset.p = v.p; card._p = v.p;
          card.querySelectorAll('[data-uwt-now]').forEach(function (e) { e.textContent = fmt(v.p); });
          card.querySelectorAll('[data-uwt-was]').forEach(function (e) { var h = e.querySelector('.visually-hidden'); e.textContent = fmt(v.c); if (h) e.prepend(h); });
          card.querySelectorAll('[data-uwt-ahorro]').forEach(function (e) { e.textContent = fmt(v.c - v.p); });
          var pct = card.querySelector('[data-uwt-pct]'); if (pct) pct.innerHTML = v.pct;
          card.querySelectorAll('.uwt-sel__o').forEach(function (o) { o.classList.toggle('is-on', o.querySelector('input') === i); });
          card.querySelectorAll('button[type=submit]').forEach(function (b) { b.disabled = !v.a; });
          if (window.dataLayer) window.dataLayer.push({ event: 'uw_ritual_variante', ritual: card.dataset.line, variante: v.t });
        });
      });
    });

    /* ── barra de envío gratis con el carrito real ── */
    var ship = root.querySelector('[data-uwt-ship]');
    function barra(total) {
      if (!ship || typeof total !== 'number') return;
      var falta = umbral - total, pct = Math.max(total > 0 ? 3 : 0, Math.min(100, Math.round(total * 100 / umbral)));
      var t = ship.querySelector('[data-uwt-ship-t]'), r = ship.querySelector('i');
      var msi = (t.textContent.match(/(\d+ o \d+) meses/) || [])[1] || '3 o 6';
      if (total <= 0) {
        t.innerHTML = '<b>Envío gratis</b> y ' + msi + ' meses sin intereses desde ' + fmt(umbral) + '.';
        ship.classList.remove('is-ok');
        if (r) r.style.width = '0%';
        return;
      }
      t.innerHTML = falta > 0
        ? 'Te faltan <b>' + fmt(falta) + '</b> para el envío gratis y ' + msi + ' meses sin intereses.'
        : 'Tu pedido ya tiene <b>envío gratis</b> y ' + msi + ' meses sin intereses.';
      ship.classList.toggle('is-ok', falta <= 0);
      if (r) r.style.width = pct + '%';
    }
    document.addEventListener('cart:update', function (e) {
      var c = e && e.detail && e.detail.resource;
      if (c && typeof c.total_price === 'number') { barra(c.total_price); return; }
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { barra(c.total_price); }).catch(function () {});
    });

    /* «Encuentra tu ritual» del menú, en la tienda, apunta a #filtrar: en el
       teléfono abre la hoja de filtros; en escritorio lleva al panel y pone
       el cursor en el buscador. Los enlaces del menú con #cabello=… llevan
       directo a los resultados ya filtrados. */
    function filtrar() {
      if (window.matchMedia('(max-width:900px)').matches) { abrir(true); return; }
      irResultados(false);
      var qi = root.querySelector('[data-uwt-q]'); if (qi) setTimeout(function () { qi.focus({ preventScroll: true }); }, 350);
    }
    function llegada(cargando) {
      var h = location.hash, pideFiltrar = h === '#filtrar', trae = /(cabello|tipo|momento|q)=/.test(h);
      if (!cargando && !pideFiltrar) st = { line: '', type: '', mom: '', q: '', sort: st.sort };
      leerHash();
      pintar('carga');
      if (pideFiltrar) filtrar();
      else if (trae) irResultados(false);
    }
    llegada(true);
    addEventListener('hashchange', function () { llegada(false); });
  }

  function all() { document.querySelectorAll('[data-uwt]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();